import { render, staticRenderFns } from "./tenant_tournament.vue?vue&type=template&id=c8e63932&"
import script from "./tenant_tournament.vue?vue&type=script&lang=js&"
export * from "./tenant_tournament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports